module.exports = __webpack_public_path__ + "static/media/39_A.3130e540.png";